import profImageDark from '../../assets/images/landiscape-dark.svg';

export default {
	title: 'dark',
	colors: {
		background: '#232423',
		title: '#fff',
		subTitle: '#EFEFEF',
		paragraphText: '#E7E7E7',
		subtext: '#ddd',
		button: '#FEFEFE',
		buttonHover: '#F4EEEE',
		box: '#373737',
		input: '#303030',
		border: '#4B4A4A',
		primary: '#61e585',
		lighter: '#4bc26f'
	},
	landiscape: profImageDark
};
